/* unplugin-vue-components disabled */import { render } from "./beforeDetail.vue?vue&type=template&id=35614f7a&scoped=true&ts=true"
import script from "./beforeDetail.vue?vue&type=script&lang=ts"
export * from "./beforeDetail.vue?vue&type=script&lang=ts"

import "./beforeDetail.vue?vue&type=style&index=0&id=35614f7a&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35614f7a"]])

export default __exports__